import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { collectPassengerInfo } from '../../utils';
import Disabilities from '../Disabilities/Disabilities';
import Radio from '../../../Radio/components/Radio';
import { BaseButton, CopyButton } from '../../../BaseComponents';
import { PassTitle } from '@entities/passengers';
const Passenger = ({ index, traveller, selectedAsAccompanying, isAccompanied, isRelinkingMode, isRelinkingAvailable, isDisabled, onSetRelinkingMode, onLinkTo, onChangePassenger }) => {
    const { Passenger: css } = useTheme('PassengersDetails');
    const { t } = useTranslation('OrderCard');
    const { travellerName, mainInfo, additionalInfo, loyaltyInfo, ticketNumbers } = collectPassengerInfo(traveller);
    const handleLinkTo = () => onLinkTo === null || onLinkTo === void 0 ? void 0 : onLinkTo(traveller.id);
    const handleSetRelinkingMode = () => onSetRelinkingMode === null || onSetRelinkingMode === void 0 ? void 0 : onSetRelinkingMode(traveller);
    const showRadioButton = Boolean(isRelinkingMode && onLinkTo);
    const showChangeButton = Boolean(!showRadioButton && onChangePassenger);
    const showDisabilities = Boolean(!isRelinkingMode && traveller.disabilities.length);
    const showChangeLinkToAdult = Boolean(isRelinkingAvailable && isAccompanied && onSetRelinkingMode);
    const ticketInfo = useMemo(() => {
        const info = {};
        if (!(ticketNumbers === null || ticketNumbers === void 0 ? void 0 : ticketNumbers.length)) {
            return info;
        }
        ticketNumbers.map((number, index) => (info[`${number}-${index}`] = (React.createElement("div", null,
            `${t('Ticket number')}: `,
            React.createElement(CopyButton, { classes: { root: css.ticket__button_root, endIcon: css.ticket__button_endIcon }, variant: "text", iconPosition: "right", text: number, copyButtonText: number, copiedButtonText: number })))));
        return info;
    }, [ticketNumbers]);
    return (React.createElement("div", { className: cn(css.passenger, { [css.relink]: isRelinkingMode }) },
        React.createElement("div", { className: css.passenger__passTitle },
            React.createElement(PassTitle, { classes: { title: css.passenger__passTitle_title }, variant: "added", title: travellerName, icon: index, fieldsMap: Object.assign({ gender: mainInfo.join(', '), document: additionalInfo.join(', '), loyalty: loyaltyInfo.join(', ') }, ticketInfo), headerButtonProps: showChangeLinkToAdult && {
                    children: t('Change link to adult'),
                    onClick: handleSetRelinkingMode
                } }),
            showRadioButton && (React.createElement(Radio, { checked: selectedAsAccompanying, onClick: handleLinkTo, disabled: isDisabled })),
            showChangeButton && (React.createElement(BaseButton, { className: css.change__button, variant: "optionEdit", onClick: onChangePassenger }, t('Change')))),
        showDisabilities && React.createElement(Disabilities, { disabilities: traveller.disabilities })));
};
export default Passenger;
